import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './FormActions.styles';

const FormGroup = props => {
  const { styles: customStyles, children, ...rest } = props;
  return (
    <div className={css(styles.actions, props.styles)} {...rest}>
      {children}
    </div>
  );
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/forms/formactions/FormActions.js